







































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppFormCheckbox from '@/components/AppFormCheckbox.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IGeneralAgentInfoInput } from '@/modules/GeneralAgent/interfaces/general-agent-form'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppTextarea,
    AppFormCheckbox
  }
})
export default class GeneralAgentFormInfo extends Vue {
  @Prop({ type: Object as () => IGeneralAgentInfoInput }) value!: IGeneralAgentInfoInput

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
